import { MoreVertOutlined, Search } from "@mui/icons-material";
import { Avatar, Grid2, TableCell, Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AddUsersIco from "../../../../assets/icons/AddUsersIco";
import EyeIco from "../../../../assets/icons/EyeIco";
import ScalesIco from "../../../../assets/icons/ScalesIco";
import UsersIco from "../../../../assets/icons/UsersIco";
import Breadcrumbs from "../../../../component/Breadcrumbs";
import CommonButton from "../../../../component/Button";
import CommonTextField from "../../../../component/Input";
import CommonLinearProgress from "../../../../component/Linearprogress";
import CustomMenuItem from "../../../../component/Menu";
import { getColor } from "../../../../utils/constants";
import CommonTable from "../../../candidates/Table";
import {
  DotColor,
  StatusChange,
  StyledFlexRowView,
} from "../../../common-components/StyledComponents";
import { StyledSpaceBetweenBox } from "../../../matches/quick-match/components/StyledComponent";

function ProposalTableList() {
  const navigate = useNavigate();
  const [selectedRows, setSelectedRows] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const [sortedData, setSortedData] = useState([
    {
      id: "01",
      projectName: "Project Atlantis",
      company: "Icanio, Inc - CT ",
      owner: "Olivia Rhye",
      score: "92",
      status: "Review Pending",
      logo: "https://mui.com/static/images/avatar/3.jpg",
      bid: "$$$",
    },
    {
      id: "02",
      projectName: "Project Artemis",
      company: "Photon",
      owner: "Lana Steiner",
      score: "62",
      status: "Review Pending",
      logo: "https://mui.com/static/images/avatar/4.jpg",
      bid: "$$$$",
    },
    {
      id: "03",
      projectName: "Project Alpha",
      company: "Barone LLC.",
      owner: "Orlando Diggs",
      score: "30",
      status: "Review Pending",
      logo: "https://mui.com/static/images/avatar/2.jpg",
      bid: "$$$$$",
    },
    {
      id: "04",
      projectName: "Project Zeta",
      company: "Binford Ltd.",
      owner: "Koray Okums",
      score: "60",
      status: "Review Pending",
      logo: "https://mui.com/static/images/avatar/1.jpg",
      bid: "$$$",
    },
  ]);
  const headerData = [
    { name: "SoWs" },
    { name: "Company" },
    { name: "Owner" },
    { name: "Bid" },
    { name: "Score" },
    { name: "Status" },
    "",
  ];

  const sortableColumns = ["SoWs"];

  const handleRowCheckboxChange = (rowId) => {
    setSelectedRows((prevSelectedRows) =>
      prevSelectedRows.includes(rowId)
        ? prevSelectedRows.filter((id) => id !== rowId)
        : [...prevSelectedRows, rowId]
    );
  };

  const handleIconClick = (event, rowData) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const menuData = [
    {
      title: "Accept Bid",
      image: <AddUsersIco />,
    },
    {
      title: "View Proposal",
      image: <ScalesIco />,
      //   disabled: true,
      // onClick: handleOpenActiveJobDialog,
      onClick: () => navigate(`/proposal-generator-view`),
    },
    {
      title: "View SoW",
      image: <EyeIco />,
      //   onClick: () => navigate(`/candidate-hub?resume=parse`),
    },
    {
      title: "Compare Proposal to SoW",
      image: <UsersIco color={"#667085"} isHeight={"16"} isWidth={"16"} />,
      //   onClick: () => navigate(`/candidate-hub?resume=parse`),
    },
  ];

  const handleTableBodyData = (row, index) => {
    return (
      <>
        {/* <TableCell>{row.id}</TableCell> */}
        <TableCell sx={{ color: "#101828", fontWeight: 500, fontSize: "16px" }}>
          {row.id}
        </TableCell>

        <TableCell sx={{ color: "#101828", fontWeight: 500, fontSize: "16px" }}>
          {row.company}
        </TableCell>
        <TableCell>
          <StyledFlexRowView>
            <Avatar
              alt={row.owner}
              // src="https://mui.com/static/images/avatar/3.jpg"
              src={row.logo}
              sx={{ width: 24, height: 24 }}
            />
            {row.owner || "-"}{" "}
          </StyledFlexRowView>
        </TableCell>
        <TableCell sx={{ color: "#101828", fontWeight: 500, fontSize: "16px" }}>
          {row.bid}
        </TableCell>
        <TableCell align="left" width={"20%"}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <CommonLinearProgress
              variant="determinate"
              value={row.score}
              flex={1}
              height={"8px"}
              borderRadius={"4px"}
              barbackgroundColor={getColor(row.score)}
            />
            <Typography>{row.score}%</Typography>
          </div>
        </TableCell>

        <TableCell>
          <StatusChange>
            <DotColor
              color={
                row.status === "Review Pending"
                  ? "#9E77ED"
                  : row.status === "Under Consideration" ||
                    row.status === "Hold"
                  ? "orange"
                  : row.status === "Available" || row.status === "Active"
                  ? "green"
                  : "#F04438"
              }
            />

            <div>{row.status}</div>

            {/* <IconButton sx={{ padding: 0 }}>
              <ChevronDownIco width={"16px"} height={"16px"} />
            </IconButton> */}
          </StatusChange>
        </TableCell>

        <TableCell>
          {/* <VisibilityOutlinedIcon
              onClick={() => handleIconClick(row)}
              style={{ cursor: "pointer" }}
            /> */}
          <MoreVertOutlined
            style={{ cursor: "pointer" }}
            onClick={(e) => handleIconClick(e, row)}
          />
          <CustomMenuItem
            open={open}
            anchorEl={anchorEl}
            handleMenuClose={handleMenuClose}
            menuData={menuData}
            boxShadow={
              "0px 0px 0px 0px rgba(16, 24, 40, 0.08),0px 3px 5px -3px rgba(16, 24, 40, 0.03)"
            }
          />
        </TableCell>
      </>
    );
  };
  return (
    <Grid2 container spacing={3} padding={"2rem"}>
      <Grid2 size={12}>
        <Breadcrumbs
          breadCrumbData={[
            // { title: "Ignite" },
            { title: "Bid Management", navigate: -1 },
            { title: "Project Atlantis Bids", active: true },
          ]}
        />
      </Grid2>
      <Grid2 size={12}>
        <StyledSpaceBetweenBox>
          <Typography variant="h2">
            {"Proposals for Project Atlantis"}
          </Typography>

          <StyledFlexRowView>
            <CommonTextField
              placeholder="Search"
              startIcon={<Search />}
              // value={titleValue}
              // onChange={handleSearchInput}
            />
            <CommonButton
              variant="outlined"
              color="#344054"
              border="#D0D5DD"
              fontWeight="600"
              value="Filters"
              // onClick={() => setFilterPopup(true)}
            />
          </StyledFlexRowView>
        </StyledSpaceBetweenBox>
      </Grid2>
      <Grid2 size={12}>
        <CommonTable
          data={sortedData}
          columns={headerData}
          sortedColumns={sortableColumns}
          onSortChange={(col) => console.log("Sort by", col)}
          onRowCheckboxChange={handleRowCheckboxChange}
          handleTableBodyData={handleTableBodyData}
          //   withCheckbox={true}
        />
      </Grid2>
    </Grid2>
  );
}

export default ProposalTableList;
